import { InformationTemplate } from 'shared';
import FestivalBreadcrumbs from '../components/FestivalBreadcrumbs';
import React, { FC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Body, Button, chakra, ContainerModal, IconPlay, Spinner, Stack, useDisclosure } from 'designsystem';
import { useRouter } from 'next/router';
import Error from 'next/error';
import { GetServerSideProps } from 'next';
import { dehydrate, QueryClient } from '@tanstack/react-query';
import loadIntlMessages from '../utils/loadIntlMessages';
import prefetchGlobals from '../utils/prefetchGlobals';

const Container: FC = () => {
    const { asPath, locale } = useRouter();
    const { formatMessage } = useIntl();
    const disclosureProps = useDisclosure({ defaultIsOpen: true });
    const query = asPath.split('?')?.[1];

    return !query ? (
        <Error statusCode={500} title="No video player found" />
    ) : (
        <InformationTemplate
            pageTitle={formatMessage({ id: "container.medialoc.title", defaultMessage: 'Voorstelling' })}
            breadcrumbs={<FestivalBreadcrumbs />}
        >
            <Stack spacing={4} alignItems="flex-start">
                <Body>
                    <FormattedMessage id="container.medialoc.line1" defaultMessage="De voorstelling is geopend in een schermvullend venster." />
                    <br />
                    <FormattedMessage id="container.medialoc.line2" defaultMessage="Druk op de start knop om het venster opnieuw te tonen." />
                </Body>
                {query && (
                    <Button onClick={disclosureProps.onOpen} leftIcon={<IconPlay />}>
                        <FormattedMessage id="container.medialoc.button" defaultMessage="Start voorstelling" />
                    </Button>
                )}
            </Stack>

            <ContainerModal closeLabel={formatMessage({defaultMessage: "Sluiten"})} {...disclosureProps}>
                <Spinner
                    width={8}
                    height={8}
                    position="fixed"
                    top="calc(50vh - var(--sizing-4))"
                    left="calc(50vw - var(--sizing-4))"
                />
                <ChakraIframe
                    src={`/${locale}/media-loc/embed?${query}`}
                    aspectRatio={16 / 9}
                    title="Container"
                    pos="relative"
                    w="100%"
                    allow="encrypted-media fullscreen *; camera *; microphone *"
                />
            </ContainerModal>
        </InformationTemplate>
    );
};

const ChakraIframe = chakra('iframe');

export const getServerSideProps: GetServerSideProps = async ({ locale }) => {
    const queryClient = new QueryClient();

    await prefetchGlobals(queryClient, locale);

    return {
        props: {
            dehydratedState: dehydrate(queryClient),
            intlMessages: await loadIntlMessages(locale),
        },
    };
};

export default Container;
